export default __webpack_public_path__ + "static/media/check-in-ms.deb46736.gif";